import { FAQSection, FAQ } from "@/components/seo/FAQSection";

const homeFaqs: FAQ[] = [
  {
    question: "What does a strategic technology advisor help founders with?",
    answer: "A strategic technology advisor helps founders make better decisions across product direction, architecture, AI adoption, vendors, engineering investment, scalability and execution governance. The role is broader than delivery: it connects technology choices to business priorities and long-term company outcomes."
  },
  {
    question: "When should a founder engage a strategic technology advisor?",
    answer: "A founder should engage a strategic technology advisor when product, AI, architecture or execution decisions begin carrying significant cost, risk or investor implications. Early involvement is especially useful before building an MVP, changing platforms, adopting AI, scaling engineering or preparing for technical due diligence."
  },
  {
    question: "How is Founder Mitra different from a development agency?",
    answer: "FounderMitra begins with business context, decision clarity and operating reality before recommending technology. We can support execution, but our role is broader: we help founders determine what should be built, why it matters, how it should scale and how execution should be governed."
  },
  {
    question: "Do you work with non-technical founders?",
    answer: "Yes, non-technical founders are often our ideal clients. We translate business intent into technical decisions, evaluate vendor proposals on your behalf, run technical due diligence on engineering hires, and make sure you are never at a disadvantage in conversations with developers, agencies, or investors."
  },
  {
    question: "Do you work with startups outside India?",
    answer: "Yes. We are India-first in our understanding of the local ecosystem, talent, costs, regulation, and the realities of building from India, but we work with founders globally. Our engagements are remote-first and structured around your timezone, with overlap windows that work across India, the UK, EU, US, and APAC."
  },
  {
    question: "What does a typical Founder Mitra engagement look like?",
    answer: "Engagements usually start with a Discovery Session: a 2-4 week deep dive into your product, technology, team, and roadmap. From there founders typically move into a strategic technology advisory retainer (3-12 months) or a focused project, investor readiness, AI enablement, MVP architecture, or a technology audit. Every engagement ends with documented decisions, not just conversations."
  },
  {
    question: "How do you charge, retainer, project, or hourly?",
    answer: "We offer three engagement formats: a one-time Discovery Session (fixed scope, fixed fee), project-based work for prototyping, audits, and investor readiness, and monthly retainers for ongoing strategic technology advisory. We do not bill hourly. The model is chosen to align our incentives with your outcomes, not our timesheet."
  },
  {
    question: "Can Founder Mitra help us prepare for investor due diligence?",
    answer: "Yes. Investor readiness is one of our most requested engagements. We prepare the tech narrative for your pitch, audit your architecture and codebase, document IP and security posture, build the technical sections of the data room, and rehearse the questions that VCs and their technical advisors will actually ask. The goal is no surprises in the room."
  },
  {
    question: "Do you help with AI strategy and AI enablement?",
    answer: "Yes. We help founders apply AI where it creates real business value, not as theatre. That includes AI feature scoping, build-vs-buy decisions, model selection, agentic workflows, prompt and evaluation systems, data and privacy guardrails, and a clear roadmap for moving from a demo to a production-grade AI capability."
  },
  {
    question: "Do you replace our engineering team or work alongside them?",
    answer: "We work alongside your existing team, internal engineers, agencies, or freelancers. We bring strategic oversight, code and architecture review, hiring support, and decision support. If you don't yet have a team, we help you structure one and match you with vetted technology partners. We never compete with your team for control."
  }
];

export function HomeFAQSection() {
  return (
    <FAQSection 
      faqs={homeFaqs}
      title="Questions founders ask us."
      subtitle="Direct answers to the questions we hear most often before we start a partnership."
      showSchema={true}
      pageUrl="https://foundermitra.com/"
    />
  );
}
